import { render } from "./Root.vue?vue&type=template&id=2006d471&lang=pug"
import script from "./Root.vue?vue&type=script&lang=js"
export * from "./Root.vue?vue&type=script&lang=js"

import "./Root.vue?vue&type=style&index=0&id=2006d471&lang=css"

import exportComponent from "/var/jenkins_home/jobs/ohm-landing/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__